<template>
  <div>
    <div class="vhp-card-filter-container" v-if="!hideFilter">
      <div class="vhp-card-filter-header">
        <span class="filter-total">{{ $t('전체') }} : {{ contents.length }}</span>
        <div class="filter-search-row">
          <div class="vhp-input search-input">
            <input class="append-icon" type="text" name="search" id="search" v-model="searchKeyword" :placeholder="$t('검색어입력')" @keyup.enter="applySearch"/>
            <img class="icon" src="@/assets/image/magnify.svg" width="16" height="16" alt="magnify" />
          </div>
          <button type="button" class="vhp-button search-btn" @click="applySearch">{{ $t('검색하기') }}</button>
        </div>
      </div>

      <ul v-if="tabs.length > 1">
        <li v-for="item in tabs" :key="item.value">
          <div class="category" @click="setTab(item.value)" :class="{active: tab === item.value}">{{ item.text }}</div>
        </li>
      </ul>

      <hr class="mb-4"/>
      <vhp-select 
        v-model="sortBy" 
        :items="[{text:$t('최신순'), value:'newest'}, {text:$t('좋아요 높은순'), value:'like'}, {text:$t('많이 본 순서'), value:'view'}]" 
        item-key="text"
        item-value="value"
      />
    </div>


    
    <div class="vhp-card-container">
      <vhp-empty v-if="filteredContents.length === 0 && !loading"/>
      <vhp-card 
        v-for="content in filteredContents.slice(0, viewLimit)"
        :key="content.id"
        :content="content"
        :base-url="baseUrl"
        :list-url="listUrl"
      />

      <div class="vhp-card-more-container"> 
        <button class="vhp-button" @click="viewLimit += 9" v-if="filteredContents.length > viewLimit">
          {{$t('더 보기')}}
        </button>

        <button class="vhp-button" @click="scrollUp()" v-else-if="filteredContents.length > 12">
          {{$t('처음으로')}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardLayout',
  props:{
    contents:{
      type: Array,
      default: () => {
        return []
      }
    },
    baseUrl:{
      type: String,
      default:'/'
    },
    listUrl:{
      type: String,
      default:'/'
    },
    hideFilter:{
      type:Boolean,
      default:false
    },
    disableScroll:{
      type: Boolean,
      default:false
    }
  },
  computed:{
    filteredContents() {
      let filteredContents = []

      if(!this.tab || this.tab === 'all') {
        filteredContents = this.contents.filter((e) => 
                              this.searchKeyword ? (e.hashTags && e.hashTags.length > 0 ? e.hashTags.filter(h => h.indexOf(this.searchKeyword.toLowerCase()) !== -1).length > 0 : false) 
                              || e.title.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) !== -1
                              || e.category.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) !== -1 : true
                            )
      } else {
        filteredContents = this.contents.filter((e) => 
                              e.hashTags && e.hashTags.length > 0 ? e.hashTags.filter(h => h.indexOf(this.tab) !== -1).length > 0 : false
                            )
                            .filter((e) => 
                              this.searchKeyword ? (e.hashTags && e.hashTags.length > 0 ? e.hashTags.filter(h => h.indexOf(this.searchKeyword.toLowerCase()) !== -1).length > 0 : false) 
                              || e.title.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) !== -1 
                              || e.category.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) !== -1 : true
                            )
      }
      if(this.sortBy) {
        if(this.sortBy === 'newest') {
          filteredContents.sort((a, b) => this.parseDate(b) - this.parseDate(a))
        } else if(this.sortBy === 'like') {
          filteredContents.sort((a, b) => (b.likeCount || 0) - (a.likeCount || 0))
        } else if(this.sortBy === 'view') {
          filteredContents.sort((a, b) => (b.viewCount || 0) - (a.viewCount || 0))
        }
      }
      return filteredContents
    },
  },
  data() {
    return {
      searchKeyword: '',
      tab:'all',
      tabs:[],
      viewLimit: 9,
      loading:true,
      sortBy: 'newest'
    }
  },

  watch:{
    contents() {
      this.generateTabs(this.contents)
    }
  },

  mounted() {
    this.generateTabs(this.contents)
    setTimeout(()=>{
      this.loading = false
    }, 1000)

    this.setTab(this.$route.query.tag)

    // 무한 스크롤 로딩
    window.addEventListener('scroll', () => {
      let scrollY = window.innerHeight + window.scrollY
      let bodyHeight = document.body.offsetHeight
      let heightRate = window.innerHeight * 0.3

      if(!this.disableScroll) {
        if(scrollY > bodyHeight - heightRate && this.filteredContents.length > this.viewLimit) {
          this.viewLimit+=9
        }
      }

      
    })
  },

  methods:{
    parseDate(item) {
      const raw = item.editedDateTime || item.editedDate || item.createdDate
      if (!raw) return 0
      if (typeof raw === 'string') return new Date(raw).getTime()
      if (raw.year != null) return new Date(raw.year, (raw.month || 1) - 1, raw.day || 1).getTime()
      if (raw instanceof Date) return raw.getTime()
      return 0
    },
    applySearch() {
      this.$forceUpdate()
    },
    scrollUp() {
      window.scrollTo(0, 0)
    },
    setTab(tab){
      if(tab)
        this.tab = tab
    },
    generateTabs(contents) {
      if(!this.contents) return
      let tabs = [{
        text:this.$t('전체'),
        value: 'all'
      }]
      let tabMap = {}
      for(let i = 0; i < contents.length; i++) {
        for(let tag in contents[i].hashTags) {
          tabMap[contents[i].hashTags[tag]] = contents[i].hashTags[tag]
        }
      }

      for(let tab in tabMap) {
        tabs.push({
          text:tab,
          value:tab
        })
      }
      this.tabs = tabs
    },
  }
}
</script>

<style lang="scss" src="./CardLayout.scss"></style>
